<template>
  <div>
    <order-monthly-calender 
      v-if="!selectedItem" 
      :calenderItems="calenderItems" 
      :config="config" 
      @selectedDayEvent="selectedDayEvent" 
      @getSelectedMonthData="getSelectedMonthData" />
    <daily-menu v-else 
      :item="selectedItem" 
      :config="dayMenuConfig" 
      title="Daily Menu"
      @done="menuPageDone"
    />
  </div>
</template>

<script>
// import orderCalender from '../json/orderCalendar.json'
import orderCalender from '../../data/orderCalendar.json'
import OrderMonthlyCalender from '@/components/OrderMonthlyCalendarz'
import DailyMenu from '@/components/DailyMenu'

export default {
  name: 'OrderMonthlyCalendar',
  components: {
    OrderMonthlyCalender,
    DailyMenu
  },
  data() {
    return {
      calenderItems: orderCalender,
      config: {
        isShowMenuDescription: true,
        isShowItemDescription: true,
        enablePrintCalender: true,
        enableNextButton: true,
        enablePrevButton: true,
        isShowCalenderTitle: true
      },
      dayMenuConfig: {
        showPrice: false,
        showTitle: true,
        showDescription: true,
        showDate: true,
        enablePrint: true,
        priceLevel: 0
      },
      selectedItem: null
    }
  },
  mounted() {
  },
  methods: {
    selectedDayEvent(item) {
      this.selectedItem = item
    },
    getSelectedMonthData() {
      alert('Emit event - Get data from api for specific month is under process')
    },
    menuPageDone() {
      console.log( "menuPageDone()" )
      this.selectedItem = null;
    }
  }
}
</script>
